/**
 * Constants for Menu Filters Component
 */

export const TIMEFRAME_PERIOD_MAP: Record<string, { period: string }> = {
  '1': { period: '7' },
  '2': { period: '7' },
  '7': { period: '7' },
  '30': { period: '7' },
  '90': { period: '14' },
  '180': { period: '14' },
  '365': { period: '14' },
};

export const DEFAULT_FILTERS = {
  SENTIMENT: 'pos,neu,neg',
  LANGUAGES: 'en,de',
  CATEGORY_EXCLUDE: 'glife',
  FEED: 'non_professional,online,print,professional',
  TIME: '7',
};

export const PRESET_NAMES = {
  DEFAULT: 'Default',
  CUSTOM: 'Custom',
  E_EVENTS: 'E events',
  S_EVENTS: 'S events',
  G_EVENTS: 'G events',
  BACKEND_DEFAULT: '_default_',
};
